import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import qs from 'query-string';
import {
  API_ENDPOINT,
  type ClientApiV1InstructorsUserIdClipsQueryString,
  getClientApiV1InstructorsUserIdClipsQueryOptions,
  useClientApiV1InstructorsUserIdClipsQuery,
} from '../../resources/@types/uccSchema';

type InstructorsUserIdClipsQueryString = Omit<
  ClientApiV1InstructorsUserIdClipsQueryString,
  'excludeClipIds'
> & {
  excludeClipIds: number[];
};
interface UseClientV1InstructorsUserIdClipsQuery {
  params: Partial<InstructorsUserIdClipsQueryString>;
  userId: number;
  options?: Parameters<typeof useClientApiV1InstructorsUserIdClipsQuery>[0]['options'];
}

const DEFAULT_PARAMS: InstructorsUserIdClipsQueryString = {
  excludeClipIds: [],
  pageNumber: 1,
  pageSize: 5,
};

export function useInstructorsUserIdClipsQuery({
  params,
  userId,
  options,
}: UseClientV1InstructorsUserIdClipsQuery) {
  return useClientApiV1InstructorsUserIdClipsQuery({
    queryKey: getInstructorsUserIdClipsQueryKey({ userId, params }),
    url: qs.stringifyUrl({
      url: API_ENDPOINT.CLIENT_V1_INSTRUCTORS_USERID_CLIPS(String(userId)),
      query: {
        ...DEFAULT_PARAMS,
        ...params,
      },
    }),
    options,
  });
}

export const getInstructorsUserIdClipsQueryOptions = ({
  params,
  userId,
  options,
}: UseClientV1InstructorsUserIdClipsQuery) =>
  getClientApiV1InstructorsUserIdClipsQueryOptions({
    queryKey: getInstructorsUserIdClipsQueryKey({ userId, params }),
    url: qs.stringifyUrl({
      url: API_ENDPOINT.CLIENT_V1_INSTRUCTORS_USERID_CLIPS(String(userId)),
      query: {
        ...DEFAULT_PARAMS,
        ...params,
      },
    }),
    options,
  });

export const getInstructorsUserIdClipsQueryKey = ({
  params,
  userId,
}: {
  params: Partial<InstructorsUserIdClipsQueryString>;
  userId: number;
}): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_INSTRUCTORS_USERID_CLIPS(String(userId)),
  { ...DEFAULT_PARAMS, ...params },
];
